import type { CommonData } from "../../../../types/common";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";

interface FinancialDeclaredProps {
  data: any;
  isLoan?: boolean;
}

interface Detail {
  label: string;
  value: any;
}
function getDebtToBeReedemed(data: CommonData) {
  if (data?.offer?.debtsToBeRedeemed) {
    return data.offer.debtsToBeRedeemed;
  }
  return data?.agentApiApplication?.application?.refinanceAmount;
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  let secondLastValidRow = -1;
  let validCount = 0;

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow;
      lastValidRow = i;
      validCount++;
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow];
}

export const FinancialDeclaredRow = ({ data, isLoan = true }: FinancialDeclaredProps) => {
  // Spain (ES) uses statistica ownExperience variables for Financial Details (Declared)
  const ownExperienceVars = data?.integrations?.statistica?.ownExperience?.variables;
  
  // Format monetary values for Spain
  const formatAmount = (amount: number | null | undefined) => amount != null ? `${new Intl.NumberFormat('es-ES').format(amount)} €` : null;
  
  const monthlyNetIncome = formatAmount(ownExperienceVars?.monthlyNetPayout);
  const otherIncome = formatAmount(ownExperienceVars?.otherIncome);
  const existingLoanCost = formatAmount(ownExperienceVars?.monthlyCostOfExistingLoans);
  const rentOrMortgage = formatAmount(ownExperienceVars?.monthlyCostRentOrMortgage);
  const affordability = ownExperienceVars?.Affordability;
  const dti = ownExperienceVars?.DTI;

  const financialDetails = [
    { label: 'Monthly net income', value: monthlyNetIncome },
    { label: 'Other income', value: otherIncome },
    { label: 'Existing loan cost (monthly)', value: existingLoanCost },
    { label: 'Rent/ mortgage (monthly)', value: rentOrMortgage },
    { label: 'OE Affordability', value: affordability },
    { label: 'OE DTI', value: dti },
  ];

  if (isLoan) {
    const debtToBeRedeemed = getDebtToBeReedemed(data);
    if (debtToBeRedeemed) {
      financialDetails.push({
        label: 'Debt to be redeemed',
        value: formatAmount(debtToBeRedeemed),
      });
    }
  }

  const lastIndexes = getIndexOfLastRow(financialDetails);

  const isEmpty = financialDetails.every(
    (detail) => detail.value === null || detail.value === undefined,
  );
  if (isEmpty) return null;
  return (
    <>
      <NormalInfoWrapper $header>Financial Details (Declared)</NormalInfoWrapper>
      {financialDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return;
        return (
          <NormalInfoWrapper
            key={`financial-declared-${index}-${detail.label}`}
            $isLast={lastIndexes.includes(index)}
          >
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        );
      })}
    </>
  );
};
